import { Directive, Input } from '@angular/core';
import { AbstractControl, NgModel } from '@angular/forms';

@Directive({
  selector: '[error]',
  host : {
    '[class.is-invalid]' : `hasError(error)`,
    '[class.is-valid]' : `noError(error)`
  }
})
export class FeedbackDirective {

    constructor() { }
    @Input() public error !: AbstractControl | NgModel | null;

    private hasError(control : AbstractControl | NgModel) {
        return control.touched && control.invalid
    }

    private noError(control : AbstractControl | NgModel) {
        return control.touched && control.valid
    }

}
